import { createSupplierItem, updateSupplierItem, syncSupplierItemPaintList } from '../../../HttpRequests/supplierItems';
import { setSubmitting } from '../State/submitting';
import handleException from '../../../Core/Helpers/handleException';
import { message } from 'antd';
import { getProps } from '../props';

export default () => async (dispatch, getState) => {

  const { onClose, didCreate, didUpdate, supplierId } = getProps();
  const { form, supplierItem } = getState().modals.SupplierItem;

  try {

    dispatch(setSubmitting(true));

    const data = { ...form };

    // Add supplier_id for new items
    if (!supplierItem && supplierId) {
      data.supplier_id = supplierId;
    }

    let savedItemId = supplierItem ? supplierItem.id : null;

    if (supplierItem) {
      await updateSupplierItem({ id: supplierItem.id, data });
      message.success('Catalog item updated successfully');
      if (didUpdate) didUpdate();
    } else {
      const response = await createSupplierItem({ data });
      savedItemId = response.data && response.data.data && response.data.data.id;
      message.success('Catalog item created successfully');
      if (didCreate) didCreate();
    }

    // Sync paint list if this is a paint item
    if (savedItemId && form.category === 'Paint & Coatings') {
      await syncSupplierItemPaintList({ id: savedItemId, data: { add: form.add_to_paint_list } });
    }

    if (onClose) onClose();

  } catch (error) {
    handleException(error);
  } finally {
    dispatch(setSubmitting(false));
  }
}
